module.exports = __webpack_public_path__ + "img/bo.740e74cd.png";